export default {"src":"/_next/static/media/education.eb8a99f6.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};